import { v4 } from 'uuid'

import trackEvent from 'utils/analytics/trackEvent'
import Environment from 'utils/environment'

export const errorModal = (_, title, message, actions, errorCode, image?) => {
  trackEvent('Container Viewed', {
    eventData: {
      object_name: 'registration.error',
      type: 'container_viewed',
      event_text: 'Container Viewed',
      screen: 'signupError',
      error: errorCode,
    },
  })

  if (image) {
    return {
      title,
      message,
      actions,
      image,
    }
  } else {
    return {
      title,
      message,
      actions,
    }
  }
}

export const generateUDID = (env: Environment, visitorID: string) => {
  if (env.get('testing')) {
    return '784e5cd1-032a-4cb5-82db-5816ee5d7af0'
  } else {
    return visitorID ? visitorID : v4()
  }
}
